import React from 'react';
import { formatDate } from '../../utils/dateFormat';
import { getOrderNumber } from '../../utils/orderTitle';
import HireBulkDialogFrame from './HireBulkDialogFrame';

/**
 * BRING ALL BACK ON HIRE — every off-hired line of an order back on hire, ONE
 * confirm, all-or-nothing (owner ruling 2026-09-28; offered only once EVERY
 * hire line is off hired). `lines` are the order's off-hired hire-list rows.
 *
 * 💷 Moves no money: the server (`POST /api/hires/orders/:orderId/re-hire-all`,
 * the single-line re-hire writer) clears the return date and sets each line's
 * status from its own dates. Adjustments stay as they are.
 *
 * `onConfirm({ item_ids })`; `error` is the caller's last server refusal.
 */
function ReHireAllDialog({ order, lines, onConfirm, onCancel, loading = false, error = '' }) {
  if (!order || !lines) return null;
  const count = lines.length;
  const noun = count === 1 ? 'line' : 'lines';
  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm({ item_ids: lines.map((l) => l.item_id) });
  };
  return (
    <HireBulkDialogFrame
      testIdPrefix="rehire-all"
      title="Bring all back on hire"
      subtitle={`${count} returned hire ${noun} on ${getOrderNumber(order)}`}
      tone="indigo"
      onSubmit={handleSubmit}
      onCancel={onCancel}
      loading={loading}
      error={error}
      footnote="All or nothing: if any line cannot come back on hire, none do."
      confirmLabel={`Bring ${count} ${noun} back`}
      busyLabel="Bringing back…"
    >
      <ul className="divide-y divide-gray-200 dark:divide-gray-700 border rounded-lg border-gray-200 dark:border-gray-700">
        {lines.map((line) => (
          <li key={line.item_id} className="px-3 py-3 space-y-1" data-testid={`rehire-all-line-${line.item_id}`}>
            <span className="block text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{line.description}</span>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {formatDate(line.hire_from)} to {formatDate(line.hire_to)}
              {line.actual_return_date && <>. Returned {formatDate(line.actual_return_date)}</>}
            </p>
          </li>
        ))}
      </ul>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        The return dates are cleared and each line's status is set from its hire dates again. No prices change.
      </p>
    </HireBulkDialogFrame>
  );
}

export default ReHireAllDialog;
